import { render, staticRenderFns } from "./AuditLogPanel.vue?vue&type=template&id=1157ed74"
import script from "./AuditLogPanel.vue?vue&type=script&lang=js"
export * from "./AuditLogPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports